import React from 'react';
import { Heading } from 'elements';
import { StyledNewsItem, StyledLink, Date } from './styled';

const getLocation = (location) => {
  if (typeof location === 'object') {
    const { basename, slug } = location;
    return `${basename}/${slug}`;

  } else if (typeof location === 'string') {
    return location;
  }
};

const NewsItem = ({title, date, location}) => {
  return (
    <StyledNewsItem>
      <StyledLink to={getLocation(location)}>
        <Heading level={5}>
          {title}
        </Heading>
        <Date>{date}</Date>
      </StyledLink>
    </StyledNewsItem>
  );
};

export default NewsItem;



// WEBPACK FOOTER //
// ./src/modules/NewsSection/components/NewsItem.jsx